/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import localeEn from '../constants/locale-en';
import localeIt from '../constants/locale-it';
import {Utils} from '../components/Utils';

const initialLocale = () => {
    Utils.log('LOCALE', 'InitialLocale');
    return Utils.getBrowserLanguage() === 'it'? localeIt : localeEn;
};

export default (state = {locale: initialLocale()}, action) => {
    switch (action.type) {
        case types.CHANGE_LOCALE:
            return {
                locale: action.locale === 'it'? localeIt : localeEn,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/locale.js